import React from 'react';
import './TeamPage.css';
import StayConnected from '../../components/StayConnected/StayConnected';

const TeamPage: React.FC = () => {
  return (
    <div className="team-page">
      <div className="team-content">
        <h1 className="team-title impact">Our Team</h1>
        
        <div className="team-members">
          <div className="team-member">
            <div className="member-image-container">
              <img
                src={require('../../assets/images/headshot-samson.jpg')}
                alt="Team Member 1"
                className="member-image"
              />
            </div>
            <h3 className="member-name impact">Ekene Obiesie</h3>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img
                src={require('../../assets/images/headshot-kamran.jpg')}
                alt="Team Member 2"
                className="member-image"
              />

            </div>
            <h3 className="member-name impact">Kamran Ramsey</h3>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img
                src={require('../../assets/images/headshot-joseph.jpg')}
                alt="Joseph Ramos"
                className="member-image"
              />
            </div>
            <h3 className="member-name impact">Joseph Ramos</h3>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img
                src={require('../../assets/images/headshot-matthew.jpg')}
                alt="Matthew Strokes"
                className="member-image"
              />
            </div>
            <h3 className="member-name impact">Matthew Strokes</h3>
          </div>

          <div className="team-member">
            <div className="member-image-container">
              <img
                src={require('../../assets/images/Ivan.jpeg')}
                alt="Ivan Tong"
                className="member-image"
              />
            </div>
            <h3 className="member-name impact">Ivan Tong</h3>
          </div>
        </div>
      </div>
      
      <StayConnected />
    </div>
  );
};

export default TeamPage; 